import { pushEventAndTrack } from '../../../helpers/taggingSerializer'

const createAnalyticsOptions = (mainProduct, processedBundle) => {
  const bundlesTrackingData = processedBundle.map(bundle => {
    const selectedAccessory = {
      id: bundle.extraId,
      price: bundle.extraPrice.now,
      quantity: 1,
      name: bundle.extraName
    }
    return {
      bundleId: `${mainProduct.productId}+${bundle.extraId}`,
      bundleItems: {
        main: {
          id: mainProduct.productId,
          price: mainProduct.price && mainProduct.price.now,
          quantity: 1,
          name: mainProduct.productName
        },
        additional: [selectedAccessory]
      },
      bundleType: 'essentialExtrasBundle',
      bundleSize: 1,
      bundlePlacement: 'hero',
      ...(bundle.bundleOffer && { bundleOffer: bundle.bundleOffer })
    }
  })

  return {
    bundles: bundlesTrackingData
  }
}

const pushAction = (mainProduct, processedBundle, callback) => {
  pushEventAndTrack({
    eventInfo: {
      eventName: 'pdpBundle_enterViewport',
      eventAction: 'PDP Bundle Enter Viewport'
    },
    attributes: createAnalyticsOptions(mainProduct, processedBundle)
  })
  if (callback) {
    callback()
  }
}

export { createAnalyticsOptions, pushAction }
